import {
  labelLarge,
  labelSmall,
  labelXSmall
} from "./chunk.GAOIIZQS.js";
import {
  r
} from "./chunk.4JTBA2KG.js";

// src/components/button/button-spacing.styles.ts
var button_spacing_styles_default = r` /* * Button spacing */ .button--small .button__interior { ${labelXSmall} font-weight: var(--sl-font-weight-semibold); } .button--medium .button__interior { ${labelSmall} font-weight: var(--sl-font-weight-semibold); } .button--large .button__interior { ${labelLarge} font-weight: var(--sl-font-weight-semibold); } .button__caret, .button--has-suffix .button__suffix { margin-right: var(--sl-spacing-small); } .button--has-prefix .button__prefix { margin-left: var(--sl-spacing-small); } .button--has-label .button__label { padding: 0 var(--sl-spacing-small); } .button--has-label.button--caret .button__label, .button--has-label.button--has-suffix .button__label { padding: 0 var(--sl-spacing-x-small) 0 var(--sl-spacing-small); } .button--has-label.button--has-prefix .button__label, .button--has-label.button--loading .button__label { padding: 0 var(--sl-spacing-small) 0 var(--sl-spacing-x-small); } .button--has-label.button--has-prefix.button--has-suffix .button__label, .button--has-label.button--has-prefix.button--caret .button__label { padding: 0 var(--sl-spacing-x-small); } `;

export {
  button_spacing_styles_default
};
